import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import gsap from "gsap";
import { GameAssets } from "src/shared/util/GameAssets";
import { soundManager } from "src/shared/UI/SoundManager";

export class BonusCounter extends PIXI.Container {
    private skeleton: Spine;
    private spearSprite: PIXI.Sprite;
    private lifeSprite: PIXI.Sprite;
    private counterText: PIXI.BitmapText;
    private counter: number = 0;

    constructor() {
        super();
        this.skeleton = Spine.from({
            skeleton: `counterJson`,
            atlas: `counterAtlas`,
        });
        this.skeleton.state.setAnimation(0, "idle", true);
        this.skeleton.scale.set(0.15);

        this.spearSprite = new PIXI.Sprite(
            GameAssets.textures.gameAtlas.textures["spear.png"],
        );
        this.spearSprite.anchor.set(0.5);
        this.spearSprite.position.set(15, 50);

        this.lifeSprite = new PIXI.Sprite(
            GameAssets.textures.gameAtlas.textures["life.png"],
        );
        this.lifeSprite.anchor.set(0.5);
        this.lifeSprite.position.set(0, -50);

        this.counterText = new PIXI.BitmapText({
            text: "5",
            style: {
                fontSize: 20,
                fontFamily: "winFont",
            },
        });
        this.counterText.position.set(0, 0);
        this.counterText.anchor.set(0.5);

        // this.skeleton.addSlotObject('life', this.counterText);
        this.addChild(this.spearSprite);
        this.addChild(this.skeleton);
        this.addChild(this.lifeSprite);
        this.addChild(this.counterText);
    }


    public setCounter(value: number) {
        this.counter = value;
        this.counterText.text = value.toString();
        gsap.to(this.counterText.scale, {
            x: 1.1,
            y: 1.1,
            duration: 0.1,
            yoyo: true,
            repeat: 1,
        });


        // this.skeleton.state.setAnimation(0, 'num_change', false);
        // this.skeleton.state.addAnimation(0, 'idle', true);
    }

    getFreespins() {
        return this.counter;
    }

    public onLandscape() {
        this.spearSprite.visible = true;
        this.position.set(-550, 80);
        this.scale.set(0.8);
    }

    public onPortrait() {
        this.spearSprite.visible = false;
        this.position.set(-250, -300);
        this.scale.set(0.8);
    }

    public decrementCounter() {
        this.setCounter(this.counter - 1);
        soundManager.playSound("freeSpinCounterDecrease");
    }
}
